<template>
    <div class="form-group">
        <div class="d-flex align-items-center mb-2">
            <button class="btn btn-sm btn-success me-1" @click="add">
                +
            </button>
            <label>{{label}}</label>
        </div>
        <div class="d-flex align-items-center mb-2" v-for="(item, i) in localValue" :key="i">
            <div class="me-1">
                {{i + 1}}. 
            </div>
            <template v-if="!options || options.length == 0">
                <slot :item="localValue[i]">
                    <input class="me-2 form-control" type="text" v-model="localValue[i]" />
                </slot>
                
            </template>
            <template v-else>
                <select class="me-2 form-control" v-model="localValue[i]">
                    <option v-for="item in getAvailableOptions(i)" :value="item">{{item}}</option>
                </select>
            </template>
            <div class="d-flex">
                <button class="btn btn-sm btn-danger ms-2" @click="remove(i)">
                    -
                </button>
                <template v-if="showMoves">
                    <button class="btn btn-sm btn-link ms-2" @click="moveUp(i)" :disabled="i == 0">
                        <icon-caret-up></icon-caret-up>
                    </button>
                    <button class="btn btn-sm btn-link ms-2" @click="moveDown(i)" :disabled="i == localValue.length - 1">
                        <icon-caret-down></icon-caret-down>
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { JsonClone } from '@/utils';
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class listFiller extends mixins(WithModel) {

    @Prop() label: string;
    @Prop() options: string[];
    @Prop() pushFunction: () => any;
    @Prop({
        default: true
    }) showMoves: boolean;

    declare localValue: string[];

    getAvailableOptions(i: number){
        return this.options.filter(x => !this.modelValue.some(c => x === c) || this.modelValue[i] === x);
    }

    add(){
        if(this.pushFunction)
            this.localValue.push(this.pushFunction());
        else
            this.localValue.push("");
    }
    remove(index){
        this.localValue.splice(index, 1);
    }

    moveUp(index: number){
        if(index <= 0)
            return;

        let toMove = JsonClone(this.localValue[index]);
        this.localValue.splice(index, 1);
        this.localValue.splice(index - 1, 0, toMove);
    }

    moveDown(index: number){
        if(index >= this.localValue.length - 1)
            return;
        

        let toMove = JsonClone(this.localValue[index]);
        this.localValue.splice(index, 1);
        this.localValue.splice(index + 1, 0, toMove);
    }

}

</script>